import columnizer from 'jquery-columnizer'

$(document).ready(function () {

    $('.reviews__list').columnize({columns: 2, buildOnce: false, lastNeverTallest: true});

    let reviewImageWrap = $(".reviews__item.review .review__image")
    let reviewsCount = $(".reviews__item.review").length

    let reviewsOnPage = 8

    $(".reviews__list .reviews__item.review").each(function (index) {

        let review = $(this)
        let reviewImages = review.find(".review-image")
        let reviewImagesCount = reviewImages.length


        review.attr("data-num", index)

        if (reviewImagesCount == 0) {
            review.addClass("js-without-image")
        }

        if (index > reviewsOnPage) {
            $(this).addClass("js-hide-review")
        }

    })


    $("#review-load").click(function (e) {
        e.preventDefault()

        $(this).removeClass().addClass("button button-loading").text("Loading")


        setTimeout(function(){
            $(".js-hide-review").each(function (index) {
                if ( index == 0) {
                 //   $(this).before("<div class='clearline'></div>")
                }
                if (index < reviewsOnPage + 1) {
                    $(this).removeClass("js-hide-review")
                }

            })
            $("#review-load").removeClass().addClass("button button-blue").text("Show more")

            let hideReviewsCount = $(".js-hide-review").length
            if (hideReviewsCount == 0) {
                $("#review-load").remove()
            }

        }, 1200)


    })


    $(".js-review-context, .review-like__button").click(function (e) {
        e.preventDefault()
    })


});